import React from 'react';
import ToolTip from "./ToolTip"

const Annotation = ({ setting, setSetting, drawingCanva }) => {
  return (
    <div>
      {setting.drawMode && (
        <ToolTip
          setting={setting}
          setSetting={setSetting}
          drawingCanva={drawingCanva}
        />
      )}

    </div>
  );
}

export default Annotation;